import { FaTools, FaMoneyBill, FaUserTie, FaRocketchat } from 'react-icons/fa';

export const sellingPoints = [
  {
    title: 'Pelbagai `Servis`',
    description: 'Bagi memudahkan urusan pelanggan dengan menyediakan pelbagai servis `one-stop centre`',
    icon: FaTools
  },
  {
    title: 'Khidmat Cucian `Di Rumah`',
    description: 'Tanpa perlu datang ke kedai. Dengan pilihan servis yang pelbagai, staff kami akan ke tempat anda untuk sedia membantu dan berkhidmat. Jimat masa dan tenaga.',
    icon: FaUserTie
  },
  {
    title: 'Harga `Berbaloi`',
    description: 'Harga yang kami tawarkan adalah mampu milik dengan kualiti dan `standard` `professional` dari team TRhine',
    icon: FaMoneyBill
  },
  {
    title: 'Respon `Pantas`',
    description: '`Team` TRhine sentiasa mencuba untuk menjawab pertanyaan pelanggan secepat mungkin',
    icon: FaRocketchat
  }
]; 